import { render } from "./Painel.vue?vue&type=template&id=3f5168b8&scoped=true"
import script from "./Painel.vue?vue&type=script&lang=js"
export * from "./Painel.vue?vue&type=script&lang=js"

import "./Painel.vue?vue&type=style&index=0&id=3f5168b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5168b8"]])

export default __exports__